
import React, {useContext} from 'react'
import {Segment, Container, Divider, Header, Button} from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import RequestNoteForm from '../../../notes/form/RequestNote/RequestNoteForm';
import {RootStoreContext} from "../../../../App/stores/RootStore";

interface DetailParams {
    requestId: string;
}

const ReSend: React.FC<DetailParams> = ({ requestId }) => {
    const rootStore = useContext(RootStoreContext)
    const { resendToTRD } = rootStore.requestStore;
    return (
        <Segment clearing>

            <Header>Re send Confirmation</Header>
            <Divider />
            <Container>
                Are you sure you want to try to resend this request to TRD
                    {/*<Divider hidden />*/}
                    {/*This Review will be unlocked from the current reviewer and go back into the request pool.*/}
                    {/*<Divider hidden />*/}
                    {/*If you are sure then please provide a note on why and then submit*/}
            </Container>

            <Divider />

            <Button
                content="Continue"
                className={'rl-btn'}
                floated='right'
                labelPosition='right'
                icon='arrow alternate circle right'
                onClick={() => resendToTRD(requestId)}
                positive
            />
        </Segment>
    )
}
export default observer(ReSend);